
import React from "react"
import { forwardRef } from "react"
import { FormControl, FormHelperText, InputAdornment } from "@mui/material"

interface InputTextFieldProps {
  label?: string
  name?: string
  value?: string | number
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  type?: string
  error?: boolean
  helperText?: string | null
  isDisabled?: boolean
  placeholder?: string
  min?: string | number
  max?: string | number
  step?: string | number
  startAdornment?: React.ReactNode
  endAdornment?: React.ReactNode
  customStyles?: React.CSSProperties
  className?: string 
}

export const InputTextField = forwardRef<HTMLInputElement, InputTextFieldProps>(
  (
    {
      label,
      name,
      value,
      onChange,
      error,
      type,
      helperText,
      isDisabled,
      placeholder,
      min,
      max,
      step,
      startAdornment,
      endAdornment,
      customStyles,
      className, 
    },
    ref,
  ) => {
    return (
      <FormControl
        error={error}
        fullWidth
        sx={{
          display: "flex",
          flexDirection: "column",
          "& .MuiFormHelperText-root": {
            minHeight: "20px",
            margin: "4px 0 0 0",
          },
        }}
      >
        {label && (
          <label
            style={{
              marginBottom: "8px",
              display: "block",
              color: "#334155",
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            {label}
          </label>
        )}
        <div
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
          }}
        >
          {startAdornment && (
            <InputAdornment position="start" style={{ position: "absolute", left: "8px" }}>
              {startAdornment}
            </InputAdornment>
          )}
          <input
            ref={ref}
            type={type}
            name={name}
            value={value}
            onChange={onChange}
            disabled={isDisabled}
            placeholder={placeholder || "Enter value"}
            min={min}
            max={max}
            step={step}
            className={className}
            style={{
              width: "100%",
              ...customStyles,
            }}
          />
          {endAdornment && (
            <InputAdornment position="end" style={{ position: "absolute", right: "8px" }}>
              {endAdornment}
            </InputAdornment>
          )}
        </div>
        <FormHelperText
          error={error}
          sx={{
            visibility: helperText ? "visible" : "hidden",
          }}
        >
          {helperText}
        </FormHelperText>
      </FormControl>
    )
  },
)

export default InputTextField

